import React, { useState, useEffect, useRef } from 'react';
import { get, post, put } from '../services/apiController';
import { TABLE_DEFAULT_LIMIT, DEBOUNCE_DELAY } from '../util/constant';
import { Table, Modal, Button, Form, FloatingLabel, Row, Col } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import { EditIcon } from './icons';
import { Link } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import PaginationInPage from './Pagination';
import useDebounce from './useDebounce';
import Breadcrumb from '../components/Breadcrumb';
// import { GrDocumentExcel } from 'react-icons/gr';

const BillParameter = () => {
  const formFields = {
    companyId: '',
    locationType: '',
    locationId: '',
    locationRefName: '',
    billType: '',
    accountId: '',
    locationOwnerName: '',
    dueDate: '',
    remarks: '',
  };
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [billParameterForm, setBillParameterForm] = useState(formFields);
  const [showConfirmModel, setShowConfirmModel] = useState(false);
  const [billParametersData, setBillParametersData] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [locationList, setLocationList] = useState([]);
  //   const clickToDownload = useRef(null);
  const [state, setState] = useState({
    billType: '',
    companyId: '',
    locationType: '',
    locationId: '',
    query: '',
  });

  const handleShow = () => {
    setShowConfirmModel(true);
    setBillParameterForm(formFields);
  };

  const handleClose = () => {
    setShowConfirmModel(false);
  };

  const handleEdit = (e, id) => {
    e.preventDefault();
    try {
      get('/bill-parameters/?id=' + id).then((res) => {
        if (res.data.rows.length) {
          const Data = res.data.rows[0];
          let locationData = loadLocationData(Data?.locationId);
          setBillParameterForm({ ...Data, locationType: locationData?.type, companyId: locationData?.companyId });
          setShowConfirmModel(true);
        } else {
          toast.error('No bill parameter found.');
        }
      });
    } catch (error) {
      console.log('error', error);
      toast.error(error?.response?.data?.data?.rows?.message || 'Something went wrong');
    }
  };

  const handleChange = (event) => {
    event.preventDefault();
    let name = event.target.name;
    let value = event.target.value;
    setBillParameterForm({ ...billParameterForm, [name]: value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if ('id' in billParameterForm) {
      try {
        await put(billParameterForm, '/bill-parameters/' + billParameterForm.id);
        toast.success('Bill parameter details updated successfully');
        setShowConfirmModel(false);
        getBillParameter();
      } catch (err) {
        toast.error(err?.response?.data?.message || err?.response?.data?.data?.message || err.message, { autoClose: 2000 });
      }
    } else {
      try {
        await post(billParameterForm, '/bill-parameters');
        toast.success('Bill parameter created successfully');
        setShowConfirmModel(false);
        getBillParameter();
      } catch (err) {
        toast.error(err?.response?.data?.message || err?.response?.data?.data?.message || err.message, { autoClose: 2000 });
      }
    }
  };

  function getBillParameter() {
    try {
      get(
        `/bill-parameters/?page=${currentPage}&limit=${TABLE_DEFAULT_LIMIT}&query=${state.query}&billType=${state.billType}&companyId=${state.companyId}&locationType=${state.locationType}&locationId=${state.locationId}`
      ).then((response) => {
        setBillParametersData(response.data.rows);
        setTotalRecords(response.data.count);
      });
    } catch (err) {
      toast.error(err.response.data.data.message);
    }
  }

  function getCompanies() {
    try {
      get(`/companies`).then((response) => {
        console.log(response.data.rows);
        setCompanyList(response.data.rows);
      });
    } catch (err) {
      toast.error(err?.response?.data?.data?.message || 'something went wrong');
    }
  }

  const getLocations = () => {
    try {
      get(`/branches`).then((response) => {
        setLocationList(response.data.rows);
      });
    } catch (err) {
      toast.error(err.response.data.data.message);
    }
  };

  const loadLocationData = (locationId) => {
    return locationList.find((item) => {
      return item?.id === parseInt(locationId);
    });
  };

  useDebounce(
    () => {
      if (currentPage !== 1) {
        setCurrentPage(1);
      } else {
        getBillParameter();
      }
    },
    [state],
    DEBOUNCE_DELAY
  );

  useEffect(() => {
    getCompanies();
    getLocations();
  }, []);

  useEffect(() => {
    console.log('commpa', companyList);
  }, [companyList]);

  useEffect(() => {
    getBillParameter();
  }, [currentPage]);

  return (
    <React.Fragment>
      <ToastContainer />
      <Breadcrumb
        navigation={[
          { link: '#', title: 'Store Operations' },
          { link: '#', title: 'Bill Management' },
          { link: '#', title: 'Master' },
          { link: '#', title: 'Bill Parameters' },
        ]}
      />
      <div className="card custom_card">
        <div className="d-flex justify-content-between card-header card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <div className="col-12 col-lg-2">
            <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
              Bill Parameters | {totalRecords ?? 0}
            </h4>
          </div>
          <div className="col-12 col-lg-2" style={{ marginRight: '12px' }}>
            <Form.Select
              value={state.billType}
              onChange={(e) => setState({ ...state, billType: e.target.value })}
              placeholder="Bill Type"
              className="input"
            >
              <option value="">Select Bill Type</option>
              <option value="Electricity">Electricity</option>
              <option value="Water">Water</option>
              <option value="Tele/Wi-Fi">Tele/Wi-Fi</option>
            </Form.Select>
          </div>
          <div className="col-12 col-lg-8 text-end">
            <div className="row align-items-center">
              <div className="col-4">
                <Form.Select
                  value={state.companyId}
                  onChange={(e) => {
                    setState({
                      ...state,
                      companyId: e.target.value,
                      locationType: '',
                      locationId: '',
                    });
                  }}
                  className="input mb-2"
                >
                  <option value="">Select Company</option>
                  {companyList.map((company) => {
                    return (
                      <option key={company?.id} value={company?.id}>
                        {company?.name}
                      </option>
                    );
                  })}
                </Form.Select>
                <Form.Control
                  value={state.query}
                  onChange={(e) => setState({ ...state, query: e.target.value })}
                  type="search"
                  placeholder="Search by account id, ref name"
                />
              </div>
              <div className="col-4">
                <Form.Select
                  value={state.locationType}
                  onChange={(e) => {
                    setState({ ...state, locationType: e.target.value, locationId: '' });
                  }}
                  className="input mb-2"
                >
                  <option value="">Select Location Type</option>
                  <option value="office">Office</option>
                  <option value="factory">Factory</option>
                  <option value="outlet">Outlet</option>
                  <option value="staff-room">Staff Room</option>
                </Form.Select>
                <Form.Select value={state.locationId} onChange={(e) => setState({ ...state, locationId: e.target.value })}>
                  <option value="">Select Location</option>
                  {locationList
                    .filter((item) => {
                      return item?.type === state.locationType && item?.companyId === parseInt(state?.companyId);
                    })
                    .map((item) => {
                      return (
                        <option key={item?.id} value={item?.id}>
                          {item?.name}
                        </option>
                      );
                    })}
                </Form.Select>
              </div>
              <div className="col-4">
                <button type="button" className="btn app-btn-default dark-color" onClick={handleShow}>
                  Add Bill Parameter
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
          <div className="row">
            <div className="col">
              <Table responsive striped bordered>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Company</th>
                    <th>Location Type</th>
                    <th>Location</th>
                    <th>Location Ref Name</th>
                    <th>Bill Type</th>
                    <th>Account ID</th>
                    <th>Location Owner</th>
                    <th>Due Date</th>
                    <th>Remarks</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(billParametersData) &&
                    billParametersData.map((item, index) => {
                      let rowspan = 1;
                      if (index > 0 && item?.Branch?.name === billParametersData[index - 1]?.Branch?.name) {
                        rowspan = 0;
                      } else {
                        for (let i = index + 1; i < billParametersData.length; i++) {
                          if (item?.Branch?.name === billParametersData[i]?.Branch?.name) {
                            rowspan++;
                          } else {
                            break;
                          }
                        }
                      }
                      return (
                        <tr key={item?.id}>
                          <td>{(currentPage - 1) * TABLE_DEFAULT_LIMIT + (index + 1)}</td>
                          {rowspan > 0 && (
                            <td rowSpan={rowspan} style={{ verticalAlign: 'middle' }}>
                              {item?.Branch?.Company?.name}
                            </td>
                          )}
                          {rowspan > 0 && (
                            <td rowSpan={rowspan} style={{ textTransform: 'capitalize', verticalAlign: 'middle' }}>
                              {item?.Branch?.type}
                            </td>
                          )}
                          {rowspan > 0 && (
                            <td rowSpan={rowspan} style={{ verticalAlign: 'middle' }}>
                              {item?.Branch?.name}
                            </td>
                          )}
                          <td>{item?.locationRefName}</td>
                          <td>{item?.billType}</td>
                          <td>{item?.accountId}</td>
                          <td>{item?.locationOwnerName}</td>
                          <td>{`${item?.dueDate} th`}</td>
                          <td>{item?.remarks}</td>
                          <td className="actions">
                            <span onClick={(e) => handleEdit(e, item?.id)} className="edit-icon">
                              <EditIcon style={{ color: 'teal' }} />
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </Table>
              <PaginationInPage
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalRecords={totalRecords}
                TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
              />
            </div>
          </div>
        </div>
      </div>
      <Modal size="lg" show={showConfirmModel} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>{'id' in billParameterForm ? 'Edit Bill Parameter' : 'Add Bill Parameter'}</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleClose}></button>
        </Modal.Header>
        <Modal.Body>
          <Form autoComplete="off" onSubmit={handleSubmit}>
            <Row>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Company" className="mb-3">
                  <Form.Select
                    className="input"
                    value={billParameterForm.companyId}
                    name="companyId"
                    onChange={handleChange}
                    placeholder="Company Id"
                    required
                  >
                    <option>Select Company</option>
                    {companyList.map((item) => (
                      <option key={item.id} id={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </Form.Select>
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel label="Location Type" className="mb-3">
                  <Form.Select
                    className="input"
                    value={billParameterForm.locationType}
                    name="locationType"
                    onChange={handleChange}
                    placeholder="Location Type"
                    required
                  >
                    <option value="">Select Location Type</option>
                    <option value="outlet">Outlet</option>
                    <option value="office">Office</option>
                    <option value="factory">Factory</option>
                    <option value="staff-room">Staff Room</option>
                  </Form.Select>
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Location" className="mb-3">
                  <Form.Select
                    value={billParameterForm.locationId}
                    name="locationId"
                    onChange={handleChange}
                    className="input mb-2"
                    required
                  >
                    <option value="">Select Location</option>
                    {locationList
                      .filter((item) => {
                        return item?.type === billParameterForm.locationType && item?.companyId === parseInt(billParameterForm.companyId);
                      })
                      .map((item) => {
                        return (
                          <option key={item?.id} value={item?.id}>
                            {item?.name}
                          </option>
                        );
                      })}
                  </Form.Select>
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Location Ref. Name" className="mb-3">
                  <Form.Control
                    className="input"
                    name="locationRefName"
                    value={billParameterForm.locationRefName}
                    onChange={handleChange}
                    type="text"
                    placeholder="Location Ref. Name"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Bill Type" className="mb-3">
                  <Form.Select
                    className="input"
                    name="billType"
                    value={billParameterForm.billType}
                    onChange={handleChange}
                    type="text"
                    placeholder="Bill Type"
                    required
                  >
                    <option value="">Select Bill Type</option>
                    <option value="Electricity">Electricity</option>
                    <option value="Water">Water</option>
                    <option value="Tele/Wi-Fi">Tele/Wi-Fi</option>
                  </Form.Select>
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Account ID" className="mb-3">
                  <Form.Control
                    className="input"
                    name="accountId"
                    value={billParameterForm.accountId}
                    onChange={handleChange}
                    type="text"
                    placeholder="Account ID"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Location Owner Name" className="mb-3">
                  <Form.Control
                    className="input"
                    name="locationOwnerName"
                    value={billParameterForm.locationOwnerName}
                    onChange={handleChange}
                    type="text"
                    placeholder="Location Owner Name"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Due Date" className="mb-3">
                  <Form.Select value={billParameterForm.dueDate} name="dueDate" onChange={handleChange} className="input mb-2" required>
                    <option value="">Select due date</option>
                    {Array.from({ length: 31 }, (_, index) => index + 1).map((item) => {
                      return (
                        <option key={item} value={item}>
                          {item}
                        </option>
                      );
                    })}
                  </Form.Select>
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Remarks" className="mb-3">
                  <Form.Control
                    className="input"
                    name="remarks"
                    value={billParameterForm.remarks}
                    onChange={handleChange}
                    type="text"
                    placeholder="Remarks"
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <div className="container text-center">
              <Button type="submit" className="add-request-btn mt-4 mb-3">
                {'id' in billParameterForm ? 'Update' : 'Add'}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default BillParameter;
